import PropTypes from "prop-types";
import { roleModuleFilter } from './constants';

const FilterForRoleComponent = (props) => {
    let show = false;
    const normalizedRol = Number(props.rol);
    const rolActions = roleModuleFilter.find((rol) => rol.Rol === normalizedRol);

    if (rolActions) {
        if (rolActions.Full) {
            show = true;
        } else {
            const hasPermission = rolActions.Filters?.includes(props.moduleAction);
            const skipUserCheck = rolActions.SkipUserCheck?.includes(props.moduleAction);

            if (hasPermission) {
                show = skipUserCheck || Number(props.userId) === Number(props.userCreatedId);
            }
        }
    }

    return show ? props.children : null;
};


FilterForRoleComponent.prototype = {
    rol: PropTypes.number.isRequired,
    userId: PropTypes.number.isRequired,
    userCreatedId: PropTypes.number.isRequired,
    moduleAction: PropTypes.string.isRequired
}


export const FilterForRole = (FilterForRoleComponent);